// extracted by mini-css-extract-plugin
export default {"skipNavButton":"_3wxLa"};